import { ErrorHandler, Injectable } from '@angular/core';
import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { environment } from 'environments/environment';

const excludedUrls = [`https://${environment.auth0.domain}`];

@Injectable({
  providedIn: 'root'
})
export class AppMonitoringService {
  private readonly appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: environment.appInsights.instrumentationKey,
      enableAutoRouteTracking: true, // Автоматическая трассировка маршрутов (SPA)
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      enableCorsCorrelation: true, // Для распределенной трассировки между доменами
      distributedTracingMode: DistributedTracingModes.W3C, // Используйте W3C Trace Context
      excludeRequestFromAutoTrackingPatterns: [`https://${environment.auth0.domain}`]
    }
  });

  constructor() {
    this.appInsights.loadAppInsights();
    // this.appInsights.trackPageView();
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  // logEvent(name: string, properties?: { [key: string]: any }) {
  //   this.appInsights.trackEvent({ name: name }, properties);
  // }

  // logMetric(name: string, average: number, properties?: { [key: string]: any }) {
  //   this.appInsights.trackMetric({ name: name, average: average }, properties);
  // }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  // logTrace(message: string, properties?: { [key: string]: any }) {
  //   this.appInsights.trackTrace({ message: message }, properties);
  // }
}
@Injectable()
export class ErrorHandlerService extends ErrorHandler {

  constructor(private readonly appMonitoringService: AppMonitoringService) {
    super();
  }

  handleError(error: Error) {
    this.appMonitoringService.logException(error); // Manually log exception
  }
}